export const constants = {
  get MaxInt(): number {
    return 2147483647;
  },

  nativeAcceptTypes: [
        //Images
        'image/jpeg',
        '.jpg',
        '.jpeg',
      
        //PNG
        'image/png',
        '.png',
      
        //WebP
        'image/webp',
        '.webp',
      
        //BMP
        'image/bmp',
        '.bmp',
      
        //TIFF
        'image/tiff',
        '.tif',
        '.tiff',
      
        //SVG
        'image/svg+xml',
        '.svg',
      
        //HEIC / HEIF
        'image/heic',
        'image/heif',
        '.heic',
        '.heif',


        //PDF
        'application/pdf',
        '.pdf',
      
        //ZIP
        'application/zip',
        '.zip',
      
        //Text
        'text/plain',
        '.txt',
        '.csv',
      
        //Excel
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        '.xlsx',
        '.xls',
      
        //Word
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        '.docx'
  ]
};
